import React, { ChangeEvent, useContext, useState } from 'react';
import { uploadPublicFile } from '../../../../../utils/s3';
import { PUBLIC_BUCKET } from '../../../../../defines';
import { getFileExtension } from '../../../../../utils/s3/utils';
import { getContentGroupUploadFileName } from '../../../../../api/contentGroup/utils';
import { ActivityIndicatorContext } from '../../../../../providers/ActivityIndicatorProvider/context';
import ProjectTextField from '../../../../../components/inputs/ProjectTextField';
import { Components } from './styled';
import { ReactComponent as AccessLinkIcon } from '../../../../../assets/icons/icon-grey-check-square-offset.svg';

const ImageFieldComponent = ({
  imagePath,
  setImagePath,
}: {
  imagePath: string | undefined;
  setImagePath: React.Dispatch<React.SetStateAction<string | undefined>>;
}) => {
  const { setIsLoading } = useContext(ActivityIndicatorContext);

  const [imageUrl, setImageUrl] = useState<string | undefined>();
  const [imageUploadProgress, setImageUploadProgress] = useState<number | undefined>(undefined);

  const onUploadPublicFile = async (e: ChangeEvent<HTMLInputElement> | undefined, fileName: string, path: string) => {
    setIsLoading(true);
    const file = e?.target?.files?.[0];
    // @ts-ignore
    const newFile = new File([file], fileName, { type: file?.type });
    if (newFile) {
      if (e && e.target && e.target.value) {
        e.target.value = '';
      }

      await uploadPublicFile(newFile, path, (progress) => {
        setImageUploadProgress(progress);
        if (progress === 100) {
          setImagePath(path);
          const link = PUBLIC_BUCKET + path;
          setImageUrl(link);
          setImageUploadProgress(undefined);
        }
      });
    }
    setIsLoading(false);
  };

  const selectHandlerForImageFile = async (event: React.ChangeEvent<HTMLInputElement> | undefined) => {
    const file = event?.target?.files?.[0];

    if (file) {
      const extension = getFileExtension(file);
      const fileName = getContentGroupUploadFileName('layer');
      const path = 'images/'.concat(fileName).concat('.', extension || '');
      await onUploadPublicFile(event, fileName, path);
    }
  };

  const onAccessFileLink = () => {
    const _imageUrl = imageUrl || PUBLIC_BUCKET + imagePath;
    window.open(_imageUrl, '_blank');
  };

  const onClearImageLink = () => {
    setImagePath(undefined);
  };

  return (
    <Components.UploadFileWrapper>
      <Components.InputMenu type='file' accept={'image/*'} id='imageFile' onChange={selectHandlerForImageFile} />
      <ProjectTextField value={imagePath || ''} disabled placeholder={'No image path'} />
      {imagePath ? (
        <>
          <Components.IconWrapper onClick={() => onAccessFileLink()}>
            <AccessLinkIcon />
          </Components.IconWrapper>
          <Components.ClearButton onClick={onClearImageLink}>Clear</Components.ClearButton>
        </>
      ) : (
        <Components.UploadButton htmlFor={'imageFile'}>
          {typeof imageUploadProgress === 'number' ? `${imageUploadProgress}%` : 'Upload Image'}
        </Components.UploadButton>
      )}
    </Components.UploadFileWrapper>
  );
};

export default ImageFieldComponent;
